import React from 'react';
import UserGroupList from '../../components/usergroups/UserGroupList';

const UserGroups: React.FC = () => {

    return (<div>
        <UserGroupList />
    </div>)
    
}

export default UserGroups;